import reformItem from "../form/src/form-item.vue";

reformItem.install = function (Vue) {
  Vue.component(reformItem.name, reformItem);
};

export default reformItem;
